import { largeDecimalFormat } from 'common/formats/formats';
import { ParserParams } from 'common/types/scalarSpreadsheet';
import commonInvestmentParser from '../../commonInvestmentParser';
import { FundInvestmentColumn } from '../useFundInvestmentSheetConfig/useFundInvestmentSheetConfig.types';

const fundInvestmentParser = (params: ParserParams<FundInvestmentColumn>) => commonInvestmentParser({
  ...params,
  options: {
    useValueDirectly: true,
    shareCountFormat: largeDecimalFormat,
    lastRowFirstColumnFormat: largeDecimalFormat
  }
})

export default fundInvestmentParser;
